<form (ngSubmit)="searchEjendom()" [formGroup]="form">
  <div class="form-group" [ngClass]="{ 'form-error': form.controls['bfeValidator'].errors }">
    <label class="form-label icon-link" for="input-type-text">
      {{ 'BfeNummer' | tekstresource }}
    </label>
    <span
      *ngIf="bfeValidator.hasError('noEjendomFound')"
      class="form-error-message"
      id="form-error-message-form-error"
      role="alert"
      >{{ 'Ejendomsnummer.NotFound' | tekstresource }}</span
    >
    <span
      *ngIf="bfeValidator.hasError('pattern')"
      class="form-error-message"
      id="form-error-message-form-error"
      role="alert"
      >{{ 'Ejendomsnummer.Max.Tegn' | tekstresource }}</span
    >
    <span
      *ngIf="bfeValidator.hasError('minlength')"
      class="form-error-message"
      id="form-error-message-form-error"
      role="alert"
      >{{ 'Ejendomsnummer.Valgt' | tekstresource }}</span
    >
    <input
      class="form-input"
      formControlName="bfeValidator"
      [placeholder]="'BfeNummer.Skriv' | tekstresource"
      id="input-type-text"
      (change)="onChangeBfeNummer()"
      name="input-type-text"
      style="max-width: 100%"
    />
  </div>
</form>
